import ListSubheader from '@material-ui/core/ListSubheader';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import ArrowIcon from '@material-ui/icons/KeyboardArrowDown';
import ViewListIcon from '@material-ui/icons/ViewList';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        listHeading: {
            color: theme.palette.secondary.dark
        },
        input: {
            color: theme.palette.primary.main
        },
        menuItem: {
            padding: '0px 12px 0px 0px',
            fontSize: '14px',
            color: '#212121'
        },
        checked: {
            color: '#616161'
        },
        dropDownIcon: {
            borderLeft: theme.palette.border.main
        }
    }, globalStyles);
};

const NoLabelInput = withStyles(theme => ({
    root: {
        marginBottom: '6px',
        border: theme.palette.border.main,
        backgroundColor: 'white',
        borderRadius: '4px',
        '&:focus': {
            borderRadius: 4,
            backgroundColor: 'white',
            border: theme.palette.border.main
        },
    },
    input: {
        width: '34px',
        position: 'relative',
        fontSize: '14px',
        borderRadius: '4px',
        backgroundColor: 'white',
        padding: '6px 2px 2px 6px',
        '&:focus': {
            borderRadius: '4px',
            backgroundColor: 'white'
        },
    },
}))(InputBase);

class OptionsSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: props.values
        };
    }

    handleChange = (event) => {
        const selected = [...this.state.selected];
        const value = event.target.value[0];
        const index = this.props.options.findIndex(option => option.value === value);
        selected[index] = !selected[index];
        this.setState({ selected });
        this.props.onSelect(selected, value, selected[index]);
    };

    render() {

        const { classes, options, visibleValues, ariaLabel } = this.props;
        const { selected } = this.state;

        return (
            <div>
                <FormControl>
                    <Select
                        data-test="option-selector"
                        multiple
                        classes={{
                            icon: classes.dropDownIcon
                        }}
                        className={classes.select}
                        style={{ width: '100%' }}
                        value={[]}
                        name="option-selector"
                        onChange={this.handleChange}
                        IconComponent={ArrowIcon}
                        renderValue={() => <ViewListIcon />}
                        displayEmpty={true}
                        input={<NoLabelInput inputProps={{ "data-test": "selected-value" }} />}
                        inputProps={{
                            "aria-label": ariaLabel,
                            className: classes.input
                        }}
                        MenuProps={{
                            "data-test": "option-selector-list",
                            transformOrigin: {
                                horizontal: 'center',
                                vertical: -50
                            }
                        }}>
                        {options.map((option, index) =>
                            visibleValues[index] ?
                                option.heading ?
                                    index < options.length - 1 ?
                                        <ListSubheader key={index} disableSticky className={classes.listHeading}>{option.label}</ListSubheader>
                                        :
                                        null
                                    :
                                    <MenuItem
                                        data-test={"option-selector-item-" + option.label}
                                        key={option.value}
                                        dense={true}
                                        className={classes.menuItem}
                                        value={option.value}>
                                        <Checkbox color="primary" className={classes.checked} checked={selected[index]} />
                                        <ListItemText
                                            primary={option.label}
                                            primaryTypographyProps={{
                                                style: {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis'
                                                }
                                            }} />
                                    </MenuItem>
                                :
                                null
                        )}
                    </Select>
                </FormControl>
            </div>
        );
    }
}

OptionsSelector.defaultProps = {
    ariaLabel: "Select options"
};

OptionsSelector.propTypes = {
    ariaLabel: PropTypes.string,
    options: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    dataTest: PropTypes.string,
    visibleValues: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(OptionsSelector);